<template>
    <div :style="{ top: '0', zIndex: 1000 }" class="wrapper">
        <div class="header">
            <button class="btnClose" @click="closeModal?.()" v-html="SVG.CLOSE_SVG">
               

            </button>
        </div>
        <div :class="customClass">
            <slot></slot>
        </div>
    </div>
</template>
    
<script >
import { defineComponent } from 'vue';
import {SVG} from "../../../components/utils/const"
export default defineComponent({
    name: 'ModalPlayerLayout',
    props: {
        closeModal: {
            type: Function
        },
        customClass: {
            type: String,
            default() {
                return "body"
            }
        }
    },
    data(){
        return{
            SVG:SVG
        }
    }
})
</script>
  
<style>
.wrapper {
    position: absolute;
    z-index: 1000;
    top: 0;
    left: 0;
    height: 100%;
    width: 50%;
    background: var(--vm-color-one-08);
    padding: 0px;
}

.video-js.vjs-classic-skin .wrapper {
    background: var(--vm-color-one-08);
}

.wrapper .header {
    display: flex;
    float: right;
}

.wrapper .header .btnClose {
    margin-left: auto;
}

.wrapper .body {
    padding-top: 1.25em;
}

.btnClose {
    border: unset;
    background-color: transparent !important;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    margin-left: auto !important;
    width: auto;
    height: auto;
    margin-right: 0.25em;
    margin-top: 0.75em
}

.btnClose svg {
    height: 14px;
    width: 14px;
}

@media screen and (max-width: 992px) {
    .wrapper {
        position: fixed;
        z-index: 51;
    }

    .wrapper .header .btnClose {
        margin-top: 10% !important;
    }
    }

@media screen and (max-width: 576px) {
    .wrapper .header .btnClose {
        margin-top: 12% !important;
    }
       
    .wrapper .body {
        font-size: 3vw;
    }

}</style>